<script>
import { required } from 'vuelidate/lib/validators'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
// import Service from './service'
import DBar from '@components/dbar'

import axios from 'axios'

export default {
  page: {
    title: 'Service SLO',
    meta: [{ name: 'description', content: 'description' }]
  },
  components: { Layout, PageHeader, DBar },
  data () {
    return {
      title: 'Service SLO',
      category: 'List',
      appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
      items: [
        {
          text: 'Home',
          href: '/'
        },
        {
          text: 'Service SLA',
          active: true
        }
      ],
      data: [],
      totalRows: 0,
      graphs: [
        {
          'source': '/pan/xdr/agg/date/day?collection=cortex_incidents&variable=incident.incident.creation_time&match=incident.incident.severity,high',
          'id': 'widget2',
          'name': 'CANTIDAD DE INCIDENTES DE SEVERIDAD ALTA',
          'cols': 'col-md-6',
          'height_class': 'tall_widget',
          'component': 'dbar',
          'type': 'bar',
          'colors': ['#DC001E'],
          'range': true,
          'refresh': 60000
        }
      ],
      wData: [
        {
          title: 'Averages - Last 30 days',
          data: [
            {
              icon: 'wind',
              text: 'Total number of resolved incidents',
              reference: 'incCount'
            },
            {
              icon: 'alert-octagon',
              text: 'High Severity Average Resolve Time',
              reference: 'incAverageResolveHigh',
              class: 'icon-dual-danger'
            },
            {
              icon: 'alert-triangle',
              text: 'Medium Severity Average Resolve Time',
              reference: 'incAverageResolveMedium',
              class: 'icon-dual-warning'
            },
            {
              text: 'All Incidents Average Resolve Time',
              reference: 'incAverageResolveAll'
            }
          ]
        },
        // {
        //   title: 'Min - Last 30 days',
        //   data: [
        //     {
        //       icon: 'wind',
        //       text: 'Total number of resolved incidents',
        //       reference: 'incCount'
        //     },
        //     {
        //       icon: 'alert-octagon',
        //       text: 'High Severity Minimum Resolve Time',
        //       reference: 'incMinResolveHigh',
        //       class: 'icon-dual-danger'
        //     },
        //     {
        //       icon: 'alert-triangle',
        //       text: 'Medium Severity Minimum Resolve Time',
        //       reference: 'incMinResolveMedium',
        //       class: 'icon-dual-warning'
        //     },
        //     {
        //       text: 'All Incidents Minimum Resolve Time',
        //       reference: 'incMinResolveAll',
        //     },
        //   ]
        // },
        {
          title: 'Max - Last 30 days',
          data: [
            {
              icon: 'wind',
              text: 'Total number of resolved incidents',
              reference: 'incCount'
            },
            {
              icon: 'alert-octagon',
              text: 'High Severity Maximum Resolve Time',
              reference: 'incMaxResolveHigh',
              class: 'icon-dual-danger'
            },
            {
              icon: 'alert-triangle',
              text: 'Medium Severity Maximum Resolve Time',
              reference: 'incMaxResolveMedium',
              class: 'icon-dual-warning'
            },
            {
              text: 'All Incidents Maximum Resolve Time',
              reference: 'incMaxResolveAll'
            }
          ]
        },
        {
          title: 'Resolve Top by Status - Last 30 days',
          data: [
            {
              reference: 'resolveStatus',
              type: 'list',
              prefix: 'Average resolve time with status '
            }
          ]
        }
      ]
    }
  },
  validations: {
    event: {
      title: { required },
      category: { required }
    }
  },
  computed: {
    computedData: function () {
      let that = this
      let ave = {}
      ave.incAverageResolveAll = ((that.data.reduce((prev, cur) => prev + cur.resolve_time_minutes, 0) / that.data.length) / 60 || 0).toFixed(2) + ' hours'
      ave.incAverageResolveHigh = ((that.data.filter(inc => inc.severity === 'high').reduce((prev, cur) => prev + cur.resolve_time_minutes, 0) / that.data.filter(inc => inc.severity === 'high').length / 60) || 0).toFixed(2) + ' hours'
      // ave.incAverageResolveHigh = that.resolveAverage('severity').high + ' hours' || 0

      ave.incAverageResolveMedium = ((that.data.filter(inc => inc.severity === 'medium').reduce((prev, cur) => prev + cur.resolve_time_minutes, 0) / that.data.filter(inc => inc.severity === 'medium').length / 60) || 0).toFixed(2) + ' hours'
      ave.incAverageResolveLow = ((that.data.filter(inc => inc.severity === 'low').reduce((prev, cur) => prev + cur.resolve_time_minutes, 0) / that.data.filter(inc => inc.severity === 'low').length / 60) || 0).toFixed(2) + ' hours'
      ave.incMinResolveAll = that.data.reduce((prev, cur) => prev < cur.resolve_time_minutes ? prev : cur.resolve_time_minutes, 1)
      ave.incMinResolveHigh = that.data.filter(inc => inc.severity === 'high').reduce((prev, cur) => prev < cur.resolve_time_minutes ? prev : cur.resolve_time_minutes, 1)
      ave.incMinResolveMedium = that.data.filter(inc => inc.severity === 'medium').reduce((prev, cur) => prev < cur.resolve_time_minutes ? prev : cur.resolve_time_minutes, 1)
      ave.incMinResolveLow = that.data.filter(inc => inc.severity === 'low').reduce((prev, cur) => prev < cur.resolve_time_minutes ? prev : cur.resolve_time_minutes, 1)
      ave.incMaxResolveAll = (that.data.reduce((prev, cur) => prev > cur.resolve_time_minutes ? prev : cur.resolve_time_minutes, 0) / 60 || 0).toFixed(2) + ' hours'
      ave.incMaxResolveHigh = (that.data.filter(inc => inc.severity === 'high').reduce((prev, cur) => prev > cur.resolve_time_minutes ? prev : cur.resolve_time_minutes, 0) / 60 || 0).toFixed(2) + ' hours'
      ave.incMaxResolveMedium = (that.data.filter(inc => inc.severity === 'medium').reduce((prev, cur) => prev > cur.resolve_time_minutes ? prev : cur.resolve_time_minutes, 0) / 60 || 0).toFixed(2) + ' hours'
      ave.incMaxResolveLow = (that.data.filter(inc => inc.severity === 'low').reduce((prev, cur) => prev > cur.resolve_time_minutes ? prev : cur.resolve_time_minutes, 0) / 60 || 0).toFixed(2) + ' hours'
      ave.incCount = (that.data.reduce((prev, cur) => prev + 1, 0))
      ave.incCountHigh = (that.data.filter(inc => inc.severity === 'high').reduce((prev, cur) => prev + 1, 0))
      ave.incCountMedium = (that.data.filter(inc => inc.severity === 'medium').reduce((prev, cur) => prev + 1, 0))
      ave.incCountLow = (that.data.filter(inc => inc.severity === 'low').reduce((prev, cur) => prev + 1, 0))
      // ave.resolveStatus = that.data.map(entry => ({[entry.status]: 1}))
      ave.resolveStatus = that.resolveAverage('status')
      ave.resolveDescription = that.resolveCalc('description')
      return ave
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      let that = this
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      // axios.get(`${baseURL}/pan/xdr/report/service?created_after_minutes=1440`).then((response) => {
      axios.get(`${baseURL}/pan/xdr/service/resolved?include=incident.incident&created_after_minutes=43200&limit=9999`).then((response) => {
        if (response.status == 200) {
          that.data = response.data.data.map(function (entry) {
            return {
              incident_id: entry.incident_id,
              status: entry.status,
              severity: entry.severity,
              description: entry.description,
              manual_severity: entry.manual_severity,
              alert_count: entry.alert_count,
              creation_time: new Date(entry.creation_time['$date']).toLocaleString(),
              modification_time: new Date(entry.modification_time['$date']).toLocaleString(),
              resolve_time_minutes: entry.resolve_time_minutes
            }
          })
        }
      })
        .catch(function (error) {
          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('idToken')
            that.$router.push({ name: 'Home' })
          }
        })
    },
    resolveCalc (key) {
      const that = this
      let res = {}
      let sum = {}
      let count = {}
      that.data.forEach(entry => {
        sum[entry[key]] = (typeof sum[entry[key]] === 'undefined') ? 0 : sum[entry[key]]
        sum[entry[key]] += entry.resolve_time_minutes
        count[entry[key]] = (typeof count[entry[key]] === 'undefined') ? 1 : count[entry[key]]
        count[entry[key]] += 1
      })
      res['count'] = count
      res['sum'] = sum
      return res
    },
    resolveAverage (key) {
      const that = this

      let res = {}
      let data = that.resolveCalc(key)

      Object.keys(data.count).forEach(key => {
        res[key] = (((data.sum[key] || 0) / (data.count[key] || 1)) / 60 || 0).toFixed(2)
      })

      let items = Object.keys(res).map(function (key) {
        return [key, res[key]]
      })

      items.sort(function (first, second) {
        return second[1] - first[1]
      })
      // that.data.forEach(entry => {
      //   sum[entry[key]] = (typeof sum[entry[key]] === 'undefined') ? 0 : sum[entry[key]]
      //   sum[entry[key]] += entry.resolve_time_minutes
      //   count[entry[key]] = (typeof count[entry[key]] === 'undefined') ? 1 : count[entry[key]]
      //   count[entry[key]] += 1
      // })
      // res['count'] = count
      // res['sum'] = sum
      return items
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
    />
    <div class="row">
      <template v-for="wD in wData">
        <div class="col-md-6 col-xl-4">
          <div class="card">
            <div class="card-body pt-2">
              <h6 class="card-title border-bottom p-3 mb-0 header-title">
                {{ wD.title }}
              </h6>
              <div
                v-for="widget in wD.data"
                :key="widget.icon"
              >
                <template v-if="widget.type === 'list'">
                  <div
                    v-for="item in computedData[widget.reference]"
                    class="media px-3 py-3 border-bottom"
                  >
                    <div class="media-body">
                      <h4 class="mt-0 mb-1 font-size-22">
                        {{ item[1] }}&nbsp;hours
                      </h4>
                      <span class="text-muted">{{ widget.prefix || '' }}<b>{{ item[0] }}</b></span>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="media px-3 py-3 border-bottom">
                    <div class="media-body">
                      <h4 class="mt-0 mb-1 font-size-22">
                        {{ computedData[widget.reference] }}
                      </h4>
                      <span class="text-muted">{{ widget.text }}</span>
                    </div>
                    <feather
                      :type="widget.icon"
                      class="align-self-center icon-lg mr-4"
                      :class="widget.class || 'icon-dual'"
                    />
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </template>
      <!--      <div class="row">-->
      <!--        <template v-for="graph in graphs">-->
      <!--          <DBar-->
      <!--              :source = graph.source-->
      <!--              :type = graph.type-->
      <!--              :colors = graph.colors-->
      <!--              :start = graph.start-->
      <!--              :end = graph.end-->
      <!--              :range = graph.range-->
      <!--          />-->
      <!--        </template>-->
      <!--      </div>-->
    </div>
  </Layout>
</template>
